//
// Sidenav
//

'use strict';

var Sidenav = (function() {

	//
	// Variables
	//

	var $sidenavToggler = $('[data-toggle="sidenav"]')


	//
	// Methods
	//

	function init($this) {

		var $sidenav = $($this.data('target'))

		if($sidenav.hasClass('show')) {
			$sidenav.removeClass('show').addClass('hide')
			// $('body').find('.sidenav-mask').remove();

		}
		else {
			$sidenav.removeClass('hide').addClass('show')
			// $('body').find('.main-content').append('<div class="sidenav-mask mask-body d-xl-none" data-toggle="sidenav" data-target='+$this.data('target')+' />');
		}
	}



	//
	// Events
	//

	if ($sidenavToggler.length) {
		// Init scroll on click
		$sidenavToggler.on('click', function(event) {
			init($(this));
		});
	}

})();
